export default __webpack_public_path__ + "static/media/edit.35ebcb35.svg";